import {MailTemplateId} from "@/libwyze-common/api/types";
import React, {ReactElement, useState} from "react";
import {StyledBoxColumn, StyledBoxColumnWithLabel} from "@/shared/StyledComponents";
import {PAGE_FRAGMENT_WIDTH_SM, PD_XLG} from "@/shared/dimens";
import {Button, TextField, Typography} from "@mui/material";
import {validateEmail} from "@/shared/text_util";
import {Api} from "../api";
import {BaseApp} from "@/shared/BaseApp";

export function SendEmailDialog({templateId, replaceStrings, onSent}: {
  templateId: MailTemplateId,
  replaceStrings?: string[][],
  onSent: () => void
}): ReactElement {
  const [email, setEmail] = useState<string>();
  const [sending, setSending] = useState<boolean>(false);
  return <StyledBoxColumn style={{width: "84dvw", maxWidth: PAGE_FRAGMENT_WIDTH_SM, padding: PD_XLG, gap: PD_XLG}}>
    <Typography variant="h6">Send Email</Typography>
    <StyledBoxColumnWithLabel label={"Email address"}>
      <TextField
        inputMode={"email"}
        size={"small"}
        value={email}
        onChange={event => setEmail(event.target.value)}/>
    </StyledBoxColumnWithLabel>
    <Button
      variant="contained"
      disabled={!validateEmail(email) || sending} onClick={() => {
      setSending(true);
      (async function () {
        try {
          await Api.getInstance().sendEmail({
            fromId: "noreply_dentwyze_in",
            to: email,
            templateId: templateId,
            replaceStrings: replaceStrings,
          });
          BaseApp.CONTEXT.showToast("Email sent!");
          onSent();
        } catch (e) {
          BaseApp.CONTEXT.showToast("Oops, something went wrong.");
        } finally {
          setSending(false);
        }
      })()
    }}>Send</Button>
  </StyledBoxColumn>;
}
